import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { QuestionComponent } from './question.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    QuestionComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
  ],
  providers: [
  ]
})
export class QuestionModule { }
